module.exports = __webpack_public_path__ + "static/media/mudanzas.cf096a03.png";